import { Row, Col, Card, Descriptions, Timeline, Tag, Empty } from 'antd';
import {
  UserAddOutlined,
  DollarOutlined,
  PictureOutlined,
  ThunderboltOutlined,
  TeamOutlined,
} from '@ant-design/icons';
import dayjs from 'dayjs';
import type { RealtimeData } from '@/types';

interface Props {
  data: RealtimeData | null;
  loading: boolean;
}

const EVENT_COLORS: Record<string, string> = {
  user_register: 'blue',
  recharge: 'green',
  image_generate: 'purple',
  ai_call: 'gold',
};

const EVENT_DOT: Record<string, React.ReactNode> = {
  user_register: <UserAddOutlined />,
  recharge: <DollarOutlined />,
  image_generate: <PictureOutlined />,
  ai_call: <ThunderboltOutlined />,
};

export default function RealtimePanel({ data, loading }: Props) {
  if (loading) return <Row gutter={16}><Col span={8}><Card loading /></Col><Col span={16}><Card loading /></Col></Row>;
  if (!data) return <Empty />;

  return (
    <Row gutter={16}>
      <Col xs={24} lg={8}>
        <Card title="今日实时概览" size="small">
          <Descriptions column={1} size="small">
            <Descriptions.Item label={<><UserAddOutlined /> 今日注册</>}>
              <strong>{data.todayRegistrations}</strong>
            </Descriptions.Item>
            <Descriptions.Item label={<><DollarOutlined /> 今日充值</>}>
              <strong style={{ color: '#52c41a' }}>¥{Number(data.todayRecharge).toFixed(2)}</strong>
            </Descriptions.Item>
            <Descriptions.Item label={<><PictureOutlined /> 今日图片</>}>
              <strong>{data.todayImages}</strong>
            </Descriptions.Item>
            <Descriptions.Item label={<><ThunderboltOutlined /> 今日AI</>}>
              <strong>{data.todayAiCalls}</strong>
            </Descriptions.Item>
            <Descriptions.Item label={<><TeamOutlined /> 活跃用户(30天)</>}>
              <strong>{data.activeUsers}</strong>
            </Descriptions.Item>
          </Descriptions>
        </Card>
      </Col>
      <Col xs={24} lg={16}>
        <Card title="最近活动" size="small">
          {data.recentEvents.length > 0 ? (
            <Timeline
              items={data.recentEvents.map(event => ({
                dot: EVENT_DOT[event.type] || undefined,
                color: EVENT_COLORS[event.type] || 'gray',
                children: (
                  <div>
                    <Tag color={EVENT_COLORS[event.type] || 'default'} style={{ fontSize: 11 }}>
                      {event.type === 'user_register' ? '注册' :
                       event.type === 'recharge' ? '充值' :
                       event.type === 'image_generate' ? '图片' :
                       event.type === 'ai_call' ? 'AI' : event.type}
                    </Tag>
                    <span>{event.message}</span>
                    <span style={{ color: '#8c8c8c', fontSize: 12, marginLeft: 8 }}>
                      {dayjs(event.timestamp).format('MM-DD HH:mm')}
                    </span>
                  </div>
                ),
              }))}
            />
          ) : (
            <Empty description="暂无活动" image={Empty.PRESENTED_IMAGE_SIMPLE} />
          )}
        </Card>
      </Col>
    </Row>
  );
}
